<template>
  <div class="pv">
    <div
      v-for="(o, i) in orders"
      :key="o.id"
      class="pv__order"
      :class="{ 'pv__order--on': i < step }"
      :style="{ opacity: i < step ? 1 : 0.4 }"
    >
      <span class="pv__order-id">{{ o.id }}</span>
      <span class="pv__order-goods">{{ o.goods }}</span>
      <span class="pv__order-status" :style="{ color: colors[o.status], background: colors[o.status] + '18', borderColor: colors[o.status] + '40' }">
        {{ statuses[o.status] }}
      </span>
    </div>
    <div v-if="step >= orders.length && run" class="pv__done">✦ 已自动处理 {{ step }} 单</div>
  </div>
</template>

<script>
export default {
  name: 'PrevOrders',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      step: 0,
      timer: null,
      orders: [
        { id: '#2841', goods: '连衣裙×2', status: 0 },
        { id: '#2840', goods: 'T恤×5', status: 1 },
        { id: '#2839', goods: '牛仔裤×1', status: 2 },
        { id: '#2838', goods: '卫衣×3', status: 3 }
      ],
      statuses: ['待处理', '已发货', '在途中', '已签收'],
      colors: ['#F59E0B', '#00C8F5', '#9B8AFB', '#4CAF7A']
    }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.step = 0; return }
      this.timer = setInterval(() => {
        this.step = Math.min(this.step + 1, this.orders.length)
        if (this.step >= this.orders.length) clearInterval(this.timer)
      }, 700)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { display: flex; flex-direction: column; gap: 5px; width: 100%; }
.pv__order {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .03);
  border: 1px solid rgba(255, 255, 255, .07);
  transition: all .35s;
}
.pv__order--on { background: rgba(255, 255, 255, .06); }
.pv__order-id { font-family: Inter; font-size: 10px; color: #8A95B0; width: 32px; flex-shrink: 0; }
.pv__order-goods { font-size: 10px; color: rgba(220, 215, 240, .7); flex: 1; }
.pv__order-status {
  padding: 2px 7px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 9px;
}
.pv__done {
  text-align: center;
  font-size: 10px;
  color: #4CAF7A;
  animation: gx-revealUp .3s both;
}
</style>
